import React from 'react';

export const SectionHeader = ({ title, subtitle, align = 'left', className = '' }) => (
  <div className={`mb-8 md:mb-12 ${align === 'center' ? 'text-center' : ''} ${className}`}>
    <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight mb-2">
      {title}
    </h2>
    {subtitle && (
      <p className="text-base md:text-lg text-muted-foreground max-w-2xl">
        {subtitle}
      </p>
    )}
    <div className={`mt-4 w-16 h-1 rounded-full bg-[hsl(var(--gold))] ${align === 'center' ? 'mx-auto' : ''}`} />
  </div>
);
